import { render, staticRenderFns } from "./cImgUploader1.vue?vue&type=template&id=62c30ca6&scoped=true"
import script from "./cImgUploader1.vue?vue&type=script&lang=js"
export * from "./cImgUploader1.vue?vue&type=script&lang=js"
import style0 from "./cImgUploader1.vue?vue&type=style&index=0&id=62c30ca6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c30ca6",
  null
  
)

export default component.exports